import { EpimsBaseEntityDto } from './epim-base.dto';

export class PipelineEncroachmentDto extends EpimsBaseEntityDto {
  PipelineEncroachmentId: string;
  EncroachmentName: string;
  EncroachmentTypeId: string;
  EncroachmentStatusId: string;
  EncroachmentDate: Date;
  Description: string;
  RecommendationAction: string;
  SubscriberId: string;
  SubscriptionUserId: string;
  AutoSerialId: string;
  CreatedPersonId: string;
  CreatedDate: string;
  LinkageCode: string;
}
